export default "__VITE_ASSET__DteKmD5C__"